<script setup lang="ts">
type Props = {
  name: string
  items: {
    label: string
    value: string | number
  }[]
  modelValue: any
  rules?: string
}

const props = withDefaults(
  defineProps<Props>(), { rules: '' },
)

const emit = defineEmits<{ (e: 'update:modelValue', value: string): void }>()

const innerValue = computed({
  get: () => props.modelValue,
  set: value => emit('update:modelValue', value),
})
</script>

<template>
  <ValidationField
    v-slot:default="{ errors }"
    v-model="innerValue"
    class="c-validationRadio"
    v-bind:name="name"
    v-bind:rules="rules"
  >
    <v-radio-group
      v-model="innerValue"
      v-bind:error-messages="errors"
      v-bind="$attrs"
    >
      <v-radio
        v-for="item in items"
        v-bind:key="item.label"
        v-bind:label="item.label"
        v-bind:value="item.value"
      />
    </v-radio-group>
  </ValidationField>
</template>

<style lang="scss" scoped>
.c-validationRadio {
  &_term {
    font-size: 14px;
  }

  &:deep(.v-input--selection-controls) {
    margin-top: 0;
  }

  &:deep(.v-input--selection-controls__input) {
    margin-right: 5px !important;
  }

  &:deep(.v-input--radio-group__input) {
    flex-wrap: wrap;
  }

  &:deep(.v-input--radio-group .v-radio) {
    margin-right: 20px;
    margin-bottom: 10px;
  }

  &:deep(.v-input--radio-group.v-input--radio-group--column .v-radio) {
    margin-right: 0;
  }
}
</style>
